import { Outlet, useParams, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { DocIntelAIChat } from '@/components/docintel-ai';
import { useStore } from '@/store/useStore';
import { useState, useEffect } from 'react';

export function AppLayout() {
  const { isSidebarOpen } = useStore();
  const { projectId } = useParams<{ projectId: string }>();
  const location = useLocation();
  const [framework, setFramework] = useState<string | undefined>();
  
  // Detect framework from route path
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/projects/')) {
      // We have a project - framework will be detected from project data
      // For now, set to undefined and let the chat component handle it
      setFramework(undefined);
    }
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-background">
      {/* Left Sidebar */}
      <Sidebar />

      {/* Main content - pushed by left sidebar, flex-1 fills remaining space */}
      <div className={`flex flex-1 flex-col min-w-0 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-0'}`}>
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 overflow-auto p-4 sm:p-6" role="main">
          <Outlet />
        </main>
      </div>
      
      {/* Global DocIntel AI Drawer (right side) - takes up space when open, collapses to 0 when closed */}
      <DocIntelAIChat
        projectId={projectId ? parseInt(projectId) : undefined}
        framework={framework}
      />
    </div>
  );
}
